import { useCellSelection } from './cell-selection'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export function useRegisterElementClickEvent() {
  const rappidContext = injectTyped(ServiceKeys.rappidContext)

  const { performSelection } = useCellSelection()

  function registerElementClickEvent(): void {
    ;(rappidContext.paper as any).on('cell:pointerclick', performSelection)
  }

  return { registerElementClickEvent }
}
